import { supabase } from "./supabase";

const {
    data: { session },
} = await supabase.auth.getSession();

const accessToken = session?.access_token;

async function extractBillData(filePath, userId, fileId) {
    // const SUPABASE_FUNCTION_URL = 'https://qottihpcuyoudgwhdelr.supabase.co/functions/v1/dynamic-endpoint';
    const SUPABASE_FUNCTION_URL = 'https://qottihpcuyoudgwhdelr.supabase.co/functions/v1/aws-service';

    const res = await fetch(SUPABASE_FUNCTION_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ file_path: filePath, user_id: userId, file_id: fileId }),
    });

    console.log(res);


    const data = await res.json();

    if (!res.ok) throw new Error(data.error || 'Failed to extract bill data');

    return data.data; // contains storeName, month, amount, otherDetails
}


export { extractBillData }